"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var basic_ctrl_1 = require("@syl-editor/core-utilities/dist/lib/basic/basic-ctrl");
var prosemirror_model_1 = require("prosemirror-model");
var typeset_1 = require("../utils/typeset");
var parse_1 = require("@syl-editor/core-utilities/dist/lib/libs/parse");
var tools_1 = require("../utils/tools");
var debounce = require("lodash.debounce");
var NAME = 'list_item';
exports.LIST_ITEM_NAME = NAME;
var getListItem = function (slice) {
    var listNode = null;
    slice.content.descendants(function (node) {
        if (node.type.name === NAME) {
            listNode = node;
            return false;
        }
        if (listNode)
            return false;
    });
    return listNode;
};
var ListItem = /** @class */ (function (_super) {
    __extends(ListItem, _super);
    function ListItem(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.props = {};
        _this.toDOMAttrs = {};
        _this.name = NAME;
        _this.tagName = function () { return 'li'; };
        _this.attrs = {
            align: {
                default: 'left'
            },
            spaceBefore: {
                default: ''
            },
            spaceAfter: {
                default: ''
            },
            spaceBoth: {
                default: ''
            },
            lineHeight: {
                default: ''
            }
        };
        _this.inline = false;
        _this.defining = false;
        _this.parseDOM = [
            {
                tag: 'li',
                defaultFontSize: 16,
                priority: 25,
                matchInnerTags: [],
                formatAttrs: function (v, dom) { return v; },
                getAttrs: function (dom) {
                    if (dom.tagName === 'LI' && this.matchInnerTags.length) {
                        var childNode = dom.querySelector(this.matchInnerTags.join(','));
                        if (childNode)
                            return false;
                    }
                    var style = dom.getAttribute('style') || '';
                    return this.formatAttrs(parse_1.parseTypesetStyle(style, undefined, this.defaultFontSize), dom);
                }
            }
        ];
        _this.toDOM = function (node) {
            var attrs = {};
            var style = parse_1.getTypesetDOMStyle(node.attrs, _this.toDOMAttrs);
            style && (attrs.style = style);
            var align = node.attrs.align;
            if (align && !'left justify'.includes(align)) {
                attrs.style = style + "list-style-position: inside;";
            }
            tools_1.setDOMAttrByConfig(_this.props.addAttributes, node, attrs);
            return ['li', attrs, 0];
        };
        if (props) {
            tools_1.addAttrsByConfig(props.addAttributes, _this.attrs);
            _this.constructParseDOM(props);
            _this.props = props;
        }
        return _this;
    }
    ListItem.prototype.constructParseDOM = function (config) {
        var _this = this;
        var _a = typeset_1.constructTypesetParseDOM(config), defaultFontSize = _a.defaultFontSize, formatAttrs = _a.formatAttrs, defaultAttrs = _a.defaultAttrs;
        this.toDOMAttrs = __assign(__assign({}, this.attrs), defaultAttrs);
        var parseRule = this.parseDOM[0];
        parseRule.defaultFontSize = defaultFontSize || 16;
        parseRule.formatAttrs = function (attrs, dom) {
            var formattedAttrs = formatAttrs(attrs);
            tools_1.getFromDOMByConfig(_this.props.addAttributes, dom, formattedAttrs);
            return formattedAttrs;
        };
        if (config.matchInnerTags) {
            this.parseDOM[0].matchInnerTags = config.matchInnerTags;
            config.matchInnerTags.forEach(function (tagName) {
                _this.parseDOM.push(__assign(__assign({}, parseRule), { tag: tagName, priority: 30, getAttrs: function (dom) {
                        var parentElement = dom.parentElement;
                        var style = dom.getAttribute('style') || '';
                        var matchList = false;
                        while (parentElement) {
                            style = parentElement.getAttribute('style') || '' + style;
                            if (parentElement.tagName.toUpperCase() === 'LI') {
                                matchList = true;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        if (!matchList)
                            return false;
                        dom.setAttribute('style', style);
                        return parseRule.getAttrs(dom);
                    } }));
            });
        }
    };
    return ListItem;
}(core_utilities_1.Block));
exports.ListItem = ListItem;
var ListItemController = /** @class */ (function (_super) {
    __extends(ListItemController, _super);
    function ListItemController(editor, store, props) {
        var _this = _super.call(this, editor, store, props) || this;
        _this.eventHandler = {
            transformPasted: function (editor, slice) {
                var $from = editor.view.state.selection.$from;
                if ($from.parent.type.name === NAME && $from.pos === $from.start()) {
                    // hack when paste at start of list_item
                    var listNode = getListItem(slice);
                    if (!listNode)
                        return slice;
                    slice.openStart += 1;
                    if (!slice.size)
                        return new prosemirror_model_1.Slice(prosemirror_model_1.Fragment.from(listNode), 1, 1);
                }
                return slice;
            }
        };
        _this.traceLevel = debounce(function () {
            var bsState = basic_ctrl_1.BSControlKey.getState(_this.editor.view.state);
            if (bsState && bsState.listNestedLevel !== _this.props.maxNestedLevel)
                _this.setLevel();
        }, 300, { leading: true });
        _this.setLevel = function () {
            var _a = _this.editor.view, state = _a.state, dispatch = _a.dispatch;
            _this.props &&
                dispatch(state.tr.setMeta(basic_ctrl_1.BSControlKey, {
                    listNestedLevel: _this.props.maxNestedLevel
                }));
        };
        _this.initLevel = function () {
            _this.setLevel();
            _this.editor.off(core_utilities_1.EventChannel.LocalEvent.EDITOR_CREATED, _this.initLevel);
        };
        _this.editorWillUnmount = function () {
            return _this.props.maxNestedLevel && _this.editor.off(core_utilities_1.EventChannel.LocalEvent.ON_CHANGE, _this.traceLevel);
        };
        _this.name = NAME;
        _this.toolbar = {
            className: 'list_item',
            tooltip: 'list_item'
        };
        editor.on(core_utilities_1.EventChannel.LocalEvent.EDITOR_CREATED, _this.initLevel);
        _this.props.maxNestedLevel && _this.editor.on(core_utilities_1.EventChannel.LocalEvent.ON_CHANGE, _this.traceLevel);
        return _this;
    }
    return ListItemController;
}(core_utilities_1.SylController));
exports.ListItemController = ListItemController;
var ListItemPlugin = /** @class */ (function (_super) {
    __extends(ListItemPlugin, _super);
    function ListItemPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = ListItemController;
        _this.Schema = ListItem;
        return _this;
    }
    return ListItemPlugin;
}(core_utilities_1.SylPlugin));
exports.ListItemPlugin = ListItemPlugin;
//# sourceMappingURL=list-item.js.map